import { Button, Modal, Pagination, Row, Table } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import productApi from '../../api/product.api'
import { userState } from '../../store/user'

const ProductReviewRefComponent = ({
  visible,
  onClose,
  onSelect,
  currentProductId,
  selectedReviewProduct, // 추가된 prop
}) => {
  const [user, setUser] = useRecoilState(userState)
  const [modalProductItemList, setModalProductItemList] = useState([])
  const [selectedRowKey, setSelectedRowKey] = useState(
    selectedReviewProduct ? [selectedReviewProduct.productId] : [],
  )
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [totalSize, setTotalSize] = useState(0)

  // 모달이 열릴 때마다 선택된 값을 현재 선택된 상품으로 설정
  useEffect(() => {
    if (visible) {
      setSelectedRowKey(
        selectedReviewProduct ? [selectedReviewProduct.productId] : [],
      )
    }
  }, [visible, selectedReviewProduct])

  const rowSelection = {
    type: 'radio',
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectedRows[0]) {
        setSelectedRowKey(selectedRowKeys)
      }
    },
    getCheckboxProps: (record) => ({
      disabled: record.product_id === parseInt(currentProductId),
      name: record.product_id,
    }),
  }

  const columns = [
    {
      title: '상품번호',
      width: 80,
      dataIndex: 'productId',
      key: 'productId',
      ellipsis: true,
    },
    {
      title: '카테고리',
      width: 120,
      dataIndex: 'categoryName',
      key: 'categoryName',
      ellipsis: true,
      render: (value) => value || '-',
    },
    {
      title: '브랜드명',
      width: 130,
      dataIndex: 'brandName',
      key: 'brandName',
      ellipsis: true,
    },
    {
      title: '상품명',
      width: 150,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '상품 상태',
      width: 100,
      dataIndex: 'isPurchase',
      key: 'isPurchase',
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity === 0) return '품절'
        return value ? '판매중' : '미판매'
      },
    },
    {
      title: '노출여부',
      width: 100,
      dataIndex: 'isShow',
      key: 'isShow',
      ellipsis: true,
      render: (value, record) => {
        if (value) {
          return '노출'
        } else {
          return '미노출'
        }
      },
    },
    {
      title: '판매가',
      width: 90,
      dataIndex: 'price1',
      key: 'price1',
      ellipsis: true,
      render: (value) => <span>{value?.toLocaleString()}</span>,
    },
    {
      title: '등록일',
      width: 160,
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      render: (value) =>
        value ? dayjs(value).format('YYYY.MM.DD. HH:mm') : '-',
    },
  ]

  useEffect(() => {
    readProductList()
  }, [offset, pageSize])

  const readProductList = async () => {
    try {
      const res = await productApi.readProductList(
        {
          offset: offset,
          pageSize: pageSize,
          productId: null,
          productMakerName: '',
          productName: '',
          brandName: '',
          productStatus: 'total', // 이게 핵심! 'total'로 설정
          category1: '',
          category2: '',
          category3: '',
          orderType: 'createdAt',
          orderBy: 'desc',
        },
        user.id,
      )

      if (res.data.code === 200) {
        setModalProductItemList(res.data.result.productDTOList)
        setTotalSize(res.data.result.totalCnt)
      } else {
        alert('정상적인 요청이 아닙니다.')
      }
    } catch (error) {
      console.log('readProductList read error', error)
    }
  }

  const handleChangePagination = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(offset)
  }

  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset(0)
    setCurrentPageNumber(1)
  }

  const handleSelect = () => {
    const selectedProduct = modalProductItemList.find(
      (item) => item.productId === selectedRowKey[0],
    )
    if (selectedProduct) {
      onSelect(selectedProduct)
      onClose()
    }
  }

  const onRow = (record) => ({
    onClick: () => {
      // 현재 수정 중인 상품이 아닐 때만 선택 가능
      if (record.productId !== parseInt(currentProductId)) {
        setSelectedRowKey([record.productId])
      }
    },
    style: {
      cursor:
        record.productId === parseInt(currentProductId)
          ? 'not-allowed'
          : 'pointer',
      backgroundColor:
        record.productId === parseInt(currentProductId) ? '#f5f5f5' : 'inherit',
      color:
        record.productId === parseInt(currentProductId) ? '#999' : 'inherit',
    },
  })

  return (
    <Modal
      title="상품 선택"
      open={visible}
      onCancel={onClose}
      width={1200}
      footer={[
        <Button key="cancel" onClick={onClose}>
          취소
        </Button>,
        <Button
          key="select"
          type="primary"
          onClick={handleSelect}
          disabled={!selectedRowKey.length}
        >
          선택
        </Button>,
      ]}
    >
      <div style={{ padding: '20px 0' }}>
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={modalProductItemList}
          bordered
          size="middle"
          rowKey="productId"
          scroll={{ x: 'calc(700px + 50%)', y: '50vh' }}
          pagination={false}
          onRow={onRow}
        />

        <Row justify="end" style={{ marginTop: 16 }}>
          <Pagination
            showQuickJumper
            showSizeChanger
            onShowSizeChange={pageSizeChange}
            total={totalSize}
            onChange={handleChangePagination}
            current={currentPageNumber}
          />
        </Row>
      </div>
    </Modal>
  )
}

export default ProductReviewRefComponent
